import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './client.js';
import { useMutation } from './mutation.js';
import { appelDeRequete, cleMetier, dansLaPortee } from './cles.js';

const chemin = (g: string, suite: string) => `/g/${encodeURIComponent(g)}/pilotage${suite}`;
export function usePilotage<T>(g: string, suite: string, actif = true) {
  return useQuery({
    queryKey: cleMetier(g, 'pilotage', suite),
    enabled: actif,
    queryFn: (contexte) =>
      api.get<T>(chemin(g, suite), { galerie: g, ...appelDeRequete(contexte) }),
  });
}
export function useGestePilotage(g: string, apres?: () => void) {
  const cache = useQueryClient();
  return useMutation(
    dansLaPortee({
      mutationFn: (
        {
          methode,
          suite,
          corps,
        }: { methode: 'post' | 'put' | 'delete'; suite: string; corps?: unknown },
        appel,
      ) =>
        methode === 'delete'
          ? api.delete(chemin(g, suite), { galerie: g, ...appel })
          : api[methode](chemin(g, suite), corps, { galerie: g, ...appel }),
      onSuccess: async () => {
        apres?.();
        await Promise.all([
          cache.invalidateQueries({ queryKey: cleMetier(g, 'pilotage') }),
          cache.invalidateQueries({ queryKey: cleMetier(g, 'tableau-de-bord') }),
        ]);
      },
    }),
  );
}
